import { ListLoader } from "@/loaders";

export default {
  countries: new ListLoader("/dictionaries/countries/", {
    setter: "dictionary/setAllCountries",
  }),
};
